import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';
import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import DetailTemplateModal from './DetailTemplateModal';
import styles from './PageTemplateModal.module.css';
import PageTemplatePicker from './PageTemplatePicker';
import TemplateController from './TemplateController';
import classNames from 'classnames';

function PageTemplateModal() {
  const controller = useController(TemplateController);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!window.featureFlags?.A_18022_add_popover_to_legacy_elements) return;

    const modal = modalRef.current;
    if (modal && modal.getAttribute('popover') === 'manual') {
      modal.showPopover();
    }
  }, []);

  const { currentTemplate, loading } = controller.state;
  let body;
  if (loading) {
    body = null;
  } else if (currentTemplate) {
    body = <DetailTemplateModal template={currentTemplate} />;
  } else {
    body = <PageTemplatePicker />;
  }

  return ReactDOM.createPortal(
    <div
      ref={modalRef}
      className={styles.modal}
      popover={
        window.featureFlags?.A_18022_add_popover_to_legacy_elements
          ? 'manual'
          : undefined
      }
    >
      <div
        className={classNames(styles.container, {
          [styles.containerCustomTemplate]: currentTemplate?.isGlobal === false,
        })}
      >
        {loading && (
          <div className={styles.loader}>
            <aha-spinner size='45px' opacity={1} />
          </div>
        )}
        {!loading && (
          <aha-modal-body style={{ overflow: 'hidden' }}>{body}</aha-modal-body>
        )}
      </div>
    </div>,
    document.body
  );
}

export default StartControllerScope(
  TemplateController,
  ApplicationView(PageTemplateModal)
);
